import { DialogContent, DialogTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

import { useOpenEmailFlow } from './hooks';
import AuthMethod from './steps/AuthMethod';
import CheckInbox from './steps/CheckInbox';
import EmailLink from './steps/EmailLink';

interface Props {
  titleIntlId: string;
  emailSent: boolean;
  afterSignInUrl: string;
  isLoadingEmailLink: boolean;
  open: boolean;
  originSourceCategory: string;
  onClose: () => void;
  onResetEmailFlow: () => void;
}

const AuthenticationDrawer = ({
  titleIntlId,
  open,
  emailSent,
  afterSignInUrl,
  isLoadingEmailLink,
  originSourceCategory,
  onClose,
  onResetEmailFlow,
}: Props) => {
  const { isEmailFlow, handleOpenEmailFlow, handleCloseEmailFlow } =
    useOpenEmailFlow();

  const handleCloseAuthDrawer = () => {
    handleCloseEmailFlow();
    onClose();
  };

  return (
    <ResponsiveDrawerDialog
      isOpen={open}
      onClose={handleCloseAuthDrawer}
      onBack={
        !isEmailFlow
          ? undefined
          : emailSent
            ? onResetEmailFlow
            : handleCloseEmailFlow
      }
      dialogProps={{ maxWidth: 'xs', disablePortal: true }}
      drawerProps={{ disablePortal: true }}
    >
      {!emailSent && !isEmailFlow && (
        <>
          <DialogTitle>
            <FormattedMessage id={titleIntlId} />
          </DialogTitle>
          <DialogContent>
            <AuthMethod
              afterSignInUrl={afterSignInUrl}
              onEmailFlow={handleOpenEmailFlow}
              originSourceCategory={originSourceCategory}
            />
          </DialogContent>
        </>
      )}
      {!emailSent && isEmailFlow && (
        <EmailLink isLoadingEmailLink={isLoadingEmailLink} />
      )}
      {emailSent && isEmailFlow && (
        <CheckInbox afterSignInUrl={afterSignInUrl} />
      )}
    </ResponsiveDrawerDialog>
  );
};

export default AuthenticationDrawer;
